
import {of as observableOf,  Observable } from 'rxjs';
import {catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ISchedulingAdHocMails, ISchedulingConfirmationMails, ISchedulingEvents, ISchedulingSaveTheDateMails, ISchedulingTicketMails } from './events-model';
import { ErrorResponse, SuccessResponse } from '../../response';

@Injectable()
export class SchedulingEventsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.scheduling.baseUrl}${environment.scheduling.prefix}${SchedulingEventsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events';

    public scheduleMail(eventId: string, data: ISchedulingEvents): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingEventsService.URL + '/' + eventId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }

    public scheduleSaveTheDateMail(eventId: string, timelineId: string, saveTheDateMailId: string, data: ISchedulingSaveTheDateMails): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingEventsService.URL + '/' + eventId + '/timelines/' + timelineId + '/savethedatemails/' + saveTheDateMailId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }

    public scheduleConfirmationMail(eventId: string, timelineId: string, confirmationMailId: string, data: ISchedulingConfirmationMails): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingEventsService.URL + '/' + eventId + '/timelines/' + timelineId + '/confirmationmails/' + confirmationMailId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }

    public scheduleAdhocMail(eventId: string, timelineId: string, adhocMailId: string, data: ISchedulingAdHocMails): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingEventsService.URL + '/' + eventId + '/timelines/' + timelineId + '/adhocmails/' + adhocMailId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }

    public scheduleTicketMail(eventId: string, timelineId: string, ticketMailId: string, data: ISchedulingTicketMails): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingEventsService.URL + '/' + eventId + '/timelines/' + timelineId + '/ticketmails/' + ticketMailId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }

    public schedulePaymentDocumentMail(eventId: string, timelineId: string, paymentDocumentMailId: string, data: ISchedulingEvents): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(SchedulingEventsService.URL + '/' + eventId + '/schedule', data).pipe(
            catchError(x => observableOf(new ErrorResponse(x.error.messages))));
    }
}
